import React, { useState } from 'react';
import LandingNavBar from "../components/LandingNavBAr";
import '../styles/contactus.css';
import api from '../api';


const ContactUs = () => {
    const [message, setMessage] = useState("");
    const [subject, setSubject] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [errors, setErrors] = useState([]);
    const [success, setSuccess] = useState([]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors([]);
        setSuccess([]);
        try {
            const res = await api.post("/api/contact_us/", { message, subject, name, email });
            if (res.status === 200) {
                setMessage("");
                setSubject("");
                setSuccess(["Your message has been received."]);
            }
        }
        catch (error) {
            setErrors([error.response.data]);
        }
    };

    return (
        <div className="contactus" >

            <LandingNavBar />

            <div className="container my-3"  >

                {/* Header */}
                <div className="text-center mb-4 rem5">
                    <p className='slogan'>Contact us</p>
                    <p className="text-muted">
                        Have questions or need assistance? We're here to help! Contact us anytime, and our team will get back to you as soon as possible.
                    </p>
                </div>

                {/* Contact Form */}
                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6">
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">
                                    Your Name
                                </label>
                                <input
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    placeholder="Enter your name"
                                    required
                                    maxLength={100}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">
                                    Email Address
                                </label>
                                <input
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    maxLength={254}
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    placeholder="Enter your email"
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="subject" className="form-label">
                                    Subject
                                </label>
                                <input
                                    value={subject}
                                    onChange={(e) => setSubject(e.target.value)}
                                    maxLength={100}
                                    type="text"
                                    className="form-control"
                                    id="subject"
                                    placeholder="Enter the subject"
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="message" className="form-label">
                                    Message
                                </label>
                                <textarea
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    maxLength={1000}
                                    className="form-control"
                                    id="message"
                                    rows="5"
                                    placeholder="Write your message here..."
                                    required
                                ></textarea>
                            </div>

                            <div className="d-grid">
                                <button type="submit" className=" navbtns btn">
                                    Send Message
                                </button>
                            </div>
                            <div className="error">
                                {<>
                                    <ul style={{ padding: "0" }}>
                                        {errors.map((error, index) => (
                                            <li key={index}>{` ${error}`}</li>
                                        ))}
                                    </ul>
                                    <ul style={{ padding: "0" }}>
                                        {success.map((error, index) => (
                                            <li style={{ "color": "green" }} key={index}>{` ${error}`}</li>
                                        ))}
                                    </ul>
                                </>
                                }
                            </div>
                        </form>
                    </div>
                </div>

                {/* Footer */}
                <div className="text-center mt-5">
                    <p className="m-0 pt-3 text-muted">&copy; 2024 GULDAG · All rights reserved.</p>
                </div>

            </div>
        </div>
    );
};
export default ContactUs;
